import { formatHeaderPhoneNumber, HeaderLogo, useUser } from "@highway/design-system";
import { IHeader } from "@highway/mbs-shared";
import { formatWebsite, getLicenseLabel } from "@highway/mbs-utils";
import { Stack, Typography } from "@mui/material";
import CMAIcon from "../../images/CMA-icon.png";

export const LOTag = ({ header }: { header: IHeader }) => (
    <>
        <Typography variant="overline" sx={(theme) => ({ color: theme.palette.primaryGreen.main })}>
            Provided By
        </Typography>
        <img
            alt="Headshot"
            src={header.headshotUrl}
            style={{ width: "64px", height: "64px", borderRadius: "64px" }}
        />
        <Stack>
            <Typography variant="body1Bold" sx={(theme) => ({ color: theme.palette.primaryGreen.main })}>
                {header.name}
            </Typography>
            <Typography variant="body1" sx={(theme) => ({ color: theme.palette.primaryGreen.main })}>
                <Stack direction="row" flexWrap={"wrap"}>
                    <span>{getLicenseLabel(header.license)} •&nbsp;</span>
                    <span>{header.company?.name}</span>
                </Stack>
            </Typography>
        </Stack>
    </>
);

export const LOCard = () => {
    const {
        user: { header },
    } = useUser();

    return (
        <Stack spacing={1} style={{ overflow: "hidden" }}>
            <LOTag header={header} />
            <Typography variant="body1" sx={(theme) => ({ color: theme.palette.primaryGreen.main })} component="div">
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {header.phoneNumbers?.map((phone, i) => {
                        return (
                            <span key={i}>
                                {i > 0 ? <>&nbsp;•&nbsp;</> : ""}
                                {`${formatHeaderPhoneNumber(phone)}`}
                            </span>
                        );
                    })}
                </div>
            </Typography>
            <Typography
                variant="body1"
                sx={(theme) => ({ color: theme.palette.primaryGreen.main })}
                style={{ lineHeight: "22px", textDecoration: "underline" }}
            >
                {header.email}
            </Typography>
            <Typography
                variant="body1"
                sx={(theme) => ({ color: theme.palette.extendedGrey1.main })}
                style={{ lineHeight: "22px", textDecoration: "underline" }}
            >
                {formatWebsite(header.websiteUrl, 30)}
            </Typography>
            <Typography variant="body2" sx={(theme) => ({ color: theme.palette.extendedGrey1.main })}>
                {header.company?.address && `${header.company.address},`}{" "}
                {header.company?.city && `${header.company.city},`} {header.company?.state}{" "}
                {header.company?.zipCode || ""}
            </Typography>
            {header.hasCMA && (
                <Stack spacing={1} direction="row" style={{ alignItems: "center" }}>
                    <img width={30} src={CMAIcon.src} alt="CMA Logo" />
                    <Typography variant="overline" sx={(theme) => ({ color: theme.palette.primaryGreen.main })}>
                        CERTIFIED MORTGAGE ADVISOR
                    </Typography>
                </Stack>
            )}
            <div>
                <HeaderLogo styleOverride={{ maxHeight: "129px" }} />
            </div>
        </Stack>
    );
};
